export const TEXT = {
  heading: 'No results for this search',
  subHeading: 'Send out a new job?',
};
